import { render, staticRenderFns } from "./historyInsect.vue?vue&type=template&id=49a96587&scoped=true&"
import script from "./historyInsect.vue?vue&type=script&lang=js&"
export * from "./historyInsect.vue?vue&type=script&lang=js&"
import style0 from "./historyInsect.vue?vue&type=style&index=0&id=49a96587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a96587",
  null
  
)

export default component.exports